"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var Role_1 = require("../../user/model/Role");

var ApprovalStatusIndication_1 = require("../model/ApprovalStatusIndication");

var RoleApprovalStatus_1 = require("../model/RoleApprovalStatus");

var RoleApprovalStatusConverter_1 = require("./RoleApprovalStatusConverter");
/**
 * @author Radek Beran
 */


var RoleApprovalStatusConverterImpl =
/*#__PURE__*/
function (_RoleApprovalStatusCo) {
  _inherits(RoleApprovalStatusConverterImpl, _RoleApprovalStatusCo);

  function RoleApprovalStatusConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, RoleApprovalStatusConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoleApprovalStatusConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RoleApprovalStatusConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new RoleApprovalStatus_1.RoleApprovalStatus(conversions.asObject(source, 'role', function (roleDoc) {
        return new Role_1.Role(roleDoc.name);
      }), conversions.asEnum(source.indication, ApprovalStatusIndication_1.ApprovalStatusIndication), utils_1.Utils.isObject(source.userInfo) ? this.userInfoConverter.toObject(source.userInfo, conversions) : null);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        role: {
          name: source.role.name
        }
      });
      Object.assign(result, {
        indication: source.indication.toString()
      });
      Object.assign(result, {
        userInfo: source.userInfo !== null ? this.userInfoConverter.toDocument(source.userInfo, conversions) : null
      });
      return result;
    }
  }]);

  return RoleApprovalStatusConverterImpl;
}(RoleApprovalStatusConverter_1.RoleApprovalStatusConverter);

RoleApprovalStatusConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], RoleApprovalStatusConverterImpl);
exports.RoleApprovalStatusConverterImpl = RoleApprovalStatusConverterImpl;